import { Button, Container, Drawer, Grid, styled } from "@mui/material";
import {
  getLatestNotifications,
  notificationRead,
  notificationReadAll,
} from "store/slices/notification/notificationSlice";

import HeaderNotification from "./Component/HeaderNotification";
import ListNotification from "./Component/ListNotification";
import useDispatch from "hooks/useDispatch";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { ROUTE_PATHS } from "routes/paths";

export function Notification({ open, onClose }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const latestNotifications = useSelector(
    (state) => state.notification.latestNotifications?.data
  );

  const handleReadAll = async () => {
    await dispatch(notificationReadAll());
    await dispatch(getLatestNotifications());
  };

  const handleNotificationClick = async (notification) => {
    if (!notification?.isRead) {
      await dispatch(notificationRead(notification.id));
      await dispatch(getLatestNotifications());
    }
  };

  useEffect(() => {
    dispatch(getLatestNotifications());

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <DrawerStyle anchor="right" open={open} onClose={onClose}>
      <Container>
        <Grid container pt={2} spacing={1}>
          <Grid item xs={12}>
            <HeaderNotification onClose={onClose} />
          </Grid>

          <Grid item xs={12} textAlign="left">
            <Button color="secondary" variant="text" onClick={handleReadAll}>
              همه را خواندم
            </Button>
          </Grid>

          <Grid item xs={12}>
            <ListNotification
              notifications={latestNotifications?.lisNotification}
              onNotificationClick={handleNotificationClick}
            />
          </Grid>
        </Grid>
      </Container>

      <SeeAllButton
        onClick={() => {
          navigate(ROUTE_PATHS.notifications);
          onClose();
        }}
        color="primary"
      >
        مشاهده همه
      </SeeAllButton>
    </DrawerStyle>
  );
}

const DrawerStyle = styled(Drawer)(({ theme }) => ({
  ".MuiPaper-root": {
    width: "100%",
    maxWidth: "400px",
    direction: "rtl",
    background: theme.palette.background.paper,
  },
}));

const SeeAllButton = styled(Button)(({ theme }) => ({
  width: "100%",
  padding: theme.spacing(1.5, 0),
  borderRadius: 0,
  position: "sticky",
  bottom: 0,
}));

export default Notification;
